import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_7 = {
  key: 1,
  class: "flex flex-row w-full items-center"
}
const _hoisted_8 = ["id", "checked"]
const _hoisted_9 = { class: "flex flex-row justify-around w-full" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { style: {"color":"grey"} }, "unknown", -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { style: {"color":"grey"} }, "unknown", -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectionBox = _resolveComponent("SelectionBox")!
  const _component_AnswerInput = _resolveComponent("AnswerInput")!
  const _component_SlButton = _resolveComponent("SlButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row py-4 rounded", [_ctx.showSave ? 'bg-green-200' : 'bg-blue-200']])
  }, [
    (_ctx.edit)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_SelectionBox, {
                id: "select-appname",
                modelValue: _ctx.currentProjectName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentProjectName) = $event)),
                label: 'Squidex App Name',
                options: _ctx.projectNameList,
                class: "m-2",
                onChange: _ctx.setProjectName
              }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
              _createVNode(_component_SelectionBox, {
                id: "select-templatetype",
                modelValue: _ctx.currentProjectType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentProjectType) = $event)),
                label: 'Template Type',
                options: _ctx.projectTypeList,
                class: "m-2",
                onChange: _ctx.setProjectType
              }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_AnswerInput, {
                modelValue: _ctx.editableProject.interventionName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editableProject.interventionName) = $event)),
                class: "m-2",
                mode: "text",
                label: "Intervention Name",
                border: false,
                "custom-size": "12",
                onChange: _ctx.saveActive
              }, null, 8 /* PROPS */, ["modelValue", "onChange"]),
              _createVNode(_component_AnswerInput, {
                modelValue: _ctx.editableProject.tsdGroupName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editableProject.tsdGroupName) = $event)),
                class: "m-2",
                mode: "text",
                label: "TSD Group",
                border: false,
                "custom-size": "12",
                onChange: _ctx.saveActive
              }, null, 8 /* PROPS */, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_AnswerInput, {
                modelValue: _ctx.editableProject.cmsClient,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editableProject.cmsClient) = $event)),
                class: "m-2",
                mode: "text",
                label: "CMS Client",
                border: false,
                "custom-size": "12",
                onChange: _ctx.saveActive
              }, null, 8 /* PROPS */, ["modelValue", "onChange"]),
              _createVNode(_component_AnswerInput, {
                modelValue: _ctx.editableProject.cmsSecret,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editableProject.cmsSecret) = $event)),
                class: "m-2",
                mode: "text",
                label: "CMS Secret",
                border: false,
                "custom-size": "12",
                onChange: _ctx.saveActive
              }, null, 8 /* PROPS */, ["modelValue", "onChange"])
            ])
          ]),
          (_ctx.showSave)
            ? (_openBlock(), _createBlock(_component_SlButton, {
                key: 0,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveProject()))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_SlButton, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteProject()))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1 /* STABLE */
          })
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("input", {
            id: `input-selectproject-${_ctx.project.projectName}`,
            class: "w-8 ml-6",
            type: "radio",
            checked: _ctx.selected,
            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.selectMe && _ctx.selectMe(...args)))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_8),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.project.projectName), 1 /* TEXT */)
            ]),
            _createElementVNode("p", null, [
              (_ctx.project.interventionName)
                ? (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString(_ctx.project.interventionName), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("strong", _hoisted_11, _hoisted_13))
            ]),
            _createElementVNode("p", null, [
              (_ctx.project.tsdGroupName)
                ? (_openBlock(), _createElementBlock("strong", _hoisted_14, _toDisplayString(_ctx.project.tsdGroupName), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("strong", _hoisted_15, _hoisted_17))
            ])
          ]),
          _renderSlot(_ctx.$slots, "default")
        ]))
  ], 2 /* CLASS */))
}